<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" :title="title" @hidden="clearModalData">
    <!-- Modal body for all modals -->
    <p class="my-4" v-if="this.body && this.body.length > 0">{{ this.body }}</p>
    <!-- file upload modal -->
    <b-row>
      <b-col cols="12">
        <b-form-file :multiple="isMultiple" v-model="filesArray" :file-name-formatter="formatNames"
          accept="image/*"></b-form-file>
        <ul class="mt-2">
          <li class="file-item" v-for="(file, index) in filesArray" :key="index">
            {{ file.name }}
          </li>
        </ul>
      </b-col>
    </b-row>
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-button variant="primary" v-if="confirmText" class="float-right mx-2" @click="modalConfirm">{{ confirmText
        }}</b-button>
      <b-button variant="light" v-if="cancelText" class="float-right mx-2" @click="modalCancel">{{ cancelText
        }}</b-button>
    </div>
  </b-modal>
</template>

<script>
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  mixins: [mediaMixin],
  components: {},
  data() {
    return {
      title: '',
      body: '',
      cbConfirm: null,
      cbCancel: null,
      confirmText: '',
      cancelText: '',
      isMultiple: false,
      filesArray: [],
    };
  },
  created() {
    this.$root.$on('modal-show-upload-files', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-upload-files', this.showModal);
  },
  methods: {
    showModal({
      title,
      body,
      cbConfirm,
      cbCancel,
      confirmText,
      cancelText,
      isMultiple,
    }) {
      this.title = title;
      this.body = body;
      this.cbConfirm = cbConfirm || null;
      this.cbCancel = cbCancel || null;
      this.confirmText = confirmText;
      this.cancelText = cancelText;
      this.isMultiple = isMultiple;
      this.filesArray = [];
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.title = null;
      this.body = null;
      this.cbConfirm = null;
      this.cbCancel = null;
      this.confirmText = null;
      this.cancelText = null;
      this.isMultiple = false;
      this.filesArray = [];
    },
    modalConfirm() {
      if (this.cbConfirm) {
        this.cbConfirm(this.filesArray);
      }
      this.hideModal();
    },
    modalCancel() {
      if (this.cbCancel) this.cbCancel();
      this.hideModal();
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      }

      return `${files.length} files selected`;
    },
  },
};
</script>
